"use strict";

var _classCallCheck = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/nobuaquino/Macrometa/Demos/crypto_trading_bot/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Tenant = /*#__PURE__*/function () {
  function Tenant(connection, email, tenantName) {
    _classCallCheck(this, Tenant);

    this._connection = connection;
    this.name = tenantName;
    this.email = email;
  }

  _createClass(Tenant, [{
    key: "createTenant",
    value: function createTenant(passwd, dcList) {
      var _this = this;

      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._connection.request({
        method: "POST",
        path: "/tenant",
        absolutePath: true,
        body: {
          dcList: Array.isArray(dcList) ? dcList.join(',') : dcList,
          email: this.email,
          passwd: passwd,
          extra: extra
        }
      }, function (res) {
        _this.name = res.body.tenant;
        return res.body;
      });
    }
  }, {
    key: "dropTenant",
    value: function dropTenant() {
      return this._connection.request({
        method: "DELETE",
        path: "/tenant/".concat(this.name),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getTenantEdgeLocations",
    value: function getTenantEdgeLocations() {
      return this._connection.request({
        method: "GET",
        path: "/datacenter/_tenant/".concat(this.name),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "tenantDetails",
    value: function tenantDetails() {
      return this._connection.request({
        method: "GET",
        path: "/tenant/".concat(this.name),
        absolutePath: true
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "modifyTenant",
    value: function modifyTenant(passwd, extra) {
      return this._connection.request({
        method: "PATCH",
        path: "/tenant/".concat(this.name),
        absolutePath: true,
        body: {
          extra: extra,
          passwd: passwd
        }
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return Tenant;
}();

exports.Tenant = Tenant;